/**
 * Kvota projektov organizacije — EN izračun za vse prikaze (T2369, N33).
 *
 * Stranski pas in glava seznama projektov sta brala isti podatek (števec iz
 * organizacije, omejitev iz naročnine), a vsak s svojo izpeljavo: stranski pas
 * je po T2075 pokazal `∞` le ob izrecni `max_projects: null`, seznam pa je
 * imel `max_projects || '∞'` — manjkajoča (še nenaložena) omejitev je bila tam
 * »neomejeno«. Izmerjeno ob T2319: seznam »16 / ∞«, stranski pas »17 / 20«.
 *
 * Merila (enaka zaledju, `apps/boq_builder/quota.py::QuotaStatus`):
 * - števec je `project_count` organizacije (`quota_project_count` — arhivirani
 *   ne štejejo, T1259),
 * - kvota je **polna**, ko `count >= limit`,
 * - brez številske omejitve (izrecni `null` = neomejeno ali podatek še ni
 *   naložen) kvota ni polna — vmesnik ne sme zavrniti, česar zaledje ne bi.
 */
export interface ProjectQuota {
  count: number;
  /** Številska omejitev; `null` = neomejeno; `undefined` = ni podatka. */
  limit: number | null | undefined;
  /** Besedilo merilnika: `N / M`, `N / ∞` ali samo `N`, ko omejitve ne poznamo. */
  label: string;
  /** Ali je omejitev dosežena (nov projekt bi zaledje zavrnilo). */
  isFull: boolean;
}

interface SubscriptionLike {
  limits?: Record<string, unknown> | null;
}

export function projectQuota(
  projectCount: number | null | undefined,
  subscription: SubscriptionLike | null | undefined,
): ProjectQuota {
  const count = projectCount || 0;
  const limits = subscription?.limits ?? undefined;
  const raw = limits ? limits.max_projects : undefined;
  const limit: number | null | undefined =
    typeof raw === 'number' ? raw : limits && 'max_projects' in limits && raw === null ? null : undefined;

  const label =
    typeof limit === 'number' ? `${count} / ${limit}` : limit === null ? `${count} / ∞` : `${count}`;

  return {
    count,
    limit,
    label,
    isFull: typeof limit === 'number' && count >= limit,
  };
}
